/**
 * 2026-10-14 (owner) · continuous monitoring under the process tree — always there, with an Add.
 *
 * The legend was drawn only when a record already had spans, and nothing could author one, so a
 * record without any showed nothing under its tree. It now stands on every record: each monitoring
 * with its unique id, an empty line when there is none, and "+ Add continuous monitoring" on an
 * editable record. Clicking one, or Add, opens its form in the right panel (SpanPanel.jsx).
 */
import React from "react";
import { Button } from "antd";
import { Plus } from "lucide-react";

import { useFieldPrefs } from "./fieldPrefs";

export default function SpanLegend({ spans = [], operations = [], selectedSpan, onSelectSpan,
  readOnly = false, onAdd }) {
  // 2026-10-28 (owner) · switched off by this viewer (floating toolbar → Show / hide fields).
  const { shown } = useFieldPrefs();
  if (!shown("left.continuous")) return null;
  return (
    <div className="u0-spanleg" data-testid="span-legend">
      <div className="lh">Continuous monitoring · runs across steps</div>
      {spans.length ? spans.map((sp, i) => {
        const params = (sp.children || []).filter((n) => n.kind === "STEP").length;
        const ends = [sp.from_step || sp.from?.operation, sp.to_step || sp.to?.operation].join(" → ");
        return (
          <button key={sp.id} type="button" className={`slg t${i % 3}`}
                  aria-current={selectedSpan === sp.id} onClick={() => onSelectSpan?.(sp.id)}>
            <i />
            <span className="n"><span className="slg-id">{sp.id}</span> {sp.name}</span>
            <span className="k">{[ends, `${params} parameter${params === 1 ? "" : "s"}`].join(" · ")}</span>
          </button>
        );
      }) : (
        <div className="slg-empty">No continuous monitoring on this record.</div>
      )}
      {!readOnly && onAdd ? (
        <Button size="small" type="dashed" icon={<Plus size={14} />} onClick={onAdd} disabled={!operations.length}
                style={{ marginTop: 6 }} data-testid="span-add">
          Add continuous monitoring
        </Button>
      ) : null}
    </div>
  );
}
